module.exports = __webpack_public_path__ + "static/img/building.service.sample1.babae69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/old-services/building.service.sample1.png
// module id = 3L2w
// module chunks = 1